import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BoardNavPopover from './BoardNavPopover';
import { useParams } from 'react-router-dom';
import { useInbox } from '../../../services/hooks/useEntity';
import BoardPinnerProvider from '../BoardPinner/BoardPinnerProvider';
import styles from './BoardNav.module.scss';
import { faBorderAll, faChevronDown } from '@fortawesome/pro-light-svg-icons';

interface BoardNavProps {
  onNavigate?: () => void;
}

const BoardNav: React.FC<BoardNavProps> = ({ onNavigate }) => {
  const { boardId = '', entityId = '' } = useParams();
  const { data: inbox } = useInbox(entityId);
  const currentBoard = inbox?.folders?.[boardId];

  return (
    <BoardPinnerProvider stories={[]}>
      {({ handleNewBoardCreate, folders }) => (
        <BoardNavPopover onNavigate={onNavigate} onCreateBoard={handleNewBoardCreate} folders={folders}>
          <div className={styles.boardNav}>
            <div className={styles.boardNavButton}>
              <FontAwesomeIcon
                icon={faBorderAll}
                className={classNames('gigg-menu__icon', styles.boardNavIcon)}
                fixedWidth
              />
              <div className={styles.boardNavTitles}>
                <div className={styles.boardNavLabel}>Boards</div>
                {currentBoard && <div className={styles.boardNavTitle}>{currentBoard.name}</div>}
              </div>
              <FontAwesomeIcon className={styles.boardNavChevron} icon={faChevronDown} />
            </div>
          </div>
        </BoardNavPopover>
      )}
    </BoardPinnerProvider>
  );
};

export default BoardNav;
